import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faList } from "@fortawesome/free-solid-svg-icons"

export const List = (props) => {
  return <FontAwesomeIcon faIcon={faList} {...props} />
}
